const state = {
  error: null,
  errorCode: null,
  isFetching: false,
  status: null,
  bookings: {},
}

export default state
